import { Icon } from '@unite-us/ui';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
export var ExpiryMessage = function ExpiryMessage(_ref) {
  var expiredDateString = _ref.expiredDateString;
  var date = moment(expiredDateString);
  var formattedDate = date.format('MM/DD/YY[ at ]h[:]mm a');
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center my-2"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconExclamationCircle",
    className: "fill-current text-red mr-1"
  }), /*#__PURE__*/React.createElement("p", null, "Per an NCTracks query performed on ", formattedDate, ", the member\u2019s enrollment in this plan has expired."));
};
ExpiryMessage.propTypes = {
  expiredDateString: PropTypes.string.isRequired
};
//# sourceMappingURL=ExpiryMessage.js.map